import { ReactElement, useRef, useState } from "react";

interface IProps {
  Id: number;
  url: string;
  onNextClick: () => void;
  onPreviousClick: () => void;
}

export function New(props: IProps): ReactElement {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);
  const normalizedUrl = String(props.url || "").replace(/\\/g, "/").replace(/^\/+/, "");
  const src = "/" + normalizedUrl;
  const isVideo = /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(normalizedUrl);

  const toggleSound = () => {
    const video = videoRef.current;
    if (!video) return;
    const nextMuted = !video.muted;
    video.muted = nextMuted;
    setIsMuted(nextMuted);
    if (video.paused) {
      video.play().catch(() => undefined);
    }
  };

  return (
    <>
      <div className="newStory">
        {isVideo ? (
          <>
            <video
              ref={videoRef}
              className="newStory-media"
              src={src}
              autoPlay
              muted
              playsInline
              loop
              preload="metadata"
            />
            <button type="button" className="story-sound-btn" onClick={toggleSound}>
              {isMuted ? "Включить звук" : "Выключить звук"}
            </button>
          </>
        ) : (
          <img className="newStory-media" src={src} alt="new" />
        )}
      </div>
    </>
  );
}
